import React, { Component } from 'react'
import { Dropdown } from 'react-bootstrap';
import PropTypes from 'prop-types';

const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
    <a href="/" ref={ref} onClick={e => {
        e.preventDefault();
        onClick(e);
    }}>
        {children}
        <span className="threedots" />
    </a>
));

export default class ColumnFilter extends Component {
    static propTypes = {
        column: PropTypes.object.isRequired,
        onFilter: PropTypes.func.isRequired
    }
    constructor(props) {
        super(props);
        this.filter = this.filter.bind(this);
        this.getValue = this.getValue.bind(this);
        this.setFocusToCallIdInput = this.setFocusToCallIdInput.bind(this);
        this.dontCloseFilterpopup = this.dontCloseFilterpopup.bind(this);
        this.dontCloseFilterpopupOnSpace = this.dontCloseFilterpopupOnSpace.bind(this);
        this.clearfilter = this.clearfilter.bind(this);
    }
    getValue() {
        return this.input.value;
    }
    filter() {
        this.props.onFilter(this.getValue());
    }
    clearfilter = () => {
        this.props.onFilter('');
        this.input.value = '';

    }
    setFocusToCallIdInput(e) {
        //React.findDOMNode(this.input).focus();
        //  e.stopPropagation();
        // e.nativeEvent.stopImmediatePropagation();
    }
    dontCloseFilterpopup(e) {
        // React.findDOMNode(this.input).focus();
        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();
    }
    dontCloseFilterpopupOnSpace(e) {
        if (e.keyCode == 13 || e.keyCode == 32) {
            e.stopPropagation();
            e.nativeEvent.stopImmediatePropagation();
        }

    }

    render() {
        return [
            <Dropdown onClick={this.setFocusToCallIdInput} className='custom-filter-btn' align="end">
                <Dropdown.Toggle as={CustomToggle} />
                <Dropdown.Menu size="sm" title="">
                    <Dropdown.Header>{`Filter ${this.props.column.text}`}</Dropdown.Header>
                    <Dropdown.Item href='#'>
                        <input
                            className='form-control form-control-sm mb-2 rounded-0'
                            onClick={this.dontCloseFilterpopup}
                            key="input"
                            ref={node => this.input = node}
                            type="text"
                            placeholder={this.props.column.text}
                            onKeyDown={this.dontCloseFilterpopupOnSpace}
                        />
                        <button
                            key="clear"
                            className="btn btn-sm clear-filter"
                            onClick={this.clearfilter}>
                            Clear
                        </button>
                        <button
                            key="submit"
                            className="btn c-filter btn-sm"
                            onClick={this.filter}>
                            Filter
                        </button>
                    </Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
        ];
    }
}
